import { PixKey } from "./key.model";
import { TipoIniciacaoTransferencia } from "./tipo-iniciacao-transacao.enum";

export class PixTransferRequest {
	numeroConta: string;
	tipoConta: string;
	agencia: number;
	descricao: string;
	documento: string;
	codigoFimAFim: string;
	tipoCanalIniciacao: string;
	tipoIniciacao: string;
	tipoIniciacaoTransferencia: TipoIniciacaoTransferencia;
	iSPBCodigo: string;
	codigoChave: PixKey;
	nome: string;
	numeroOrigem: number;
	codigoRequisicao: string;
	dataAgendamento: string;
	horaAgendamento: number;
	codigoTransacaoQrCode: string;
	valor: number;
	desconto: number;
	multa: number;
	juros: number;
	original: number;
	abatimento: number;
	salvarFavorecido: boolean;
	
}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/master/pix/models/transfer-request.model.ts